/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";

export type SvgIconProps = React.ComponentPropsWithoutRef<"svg"> & {
  name?: string;
  containerProps?: React.ComponentPropsWithoutRef<"div">;
};

const SvgIcon = ({ name, className, containerProps, ...rest }: SvgIconProps): JSX.Element => {
  const containerClass = className ? `svg-icon ${className}` : "svg-icon";

  return (
    <div className={containerClass} {...containerProps}>
      <svg className={`icon icon-${name}`} {...rest}>
        <use xlinkHref={`#${name}`}></use>
      </svg>
    </div>
  );
};

export default SvgIcon;
